import { TreatmentsWithConfig } from '@splitsoftware/splitio/types/splitio';
import { client } from 'src/services/datadog/client';
import { isServerSide } from 'src/utils/validators/isServerSide';

declare global {
    // Required to extend global
    // eslint-disable-next-line no-var
    var zhlExperiments: TreatmentsWithConfig | undefined;
    // eslint-disable-next-line no-var
    var Cypress: boolean | undefined;
    // eslint-disable-next-line no-var
    var CypressEnableDownloads: boolean | undefined;
}

export const initExperiments = async (experiments: TreatmentsWithConfig) => {
    if (isServerSide()) {
        // eslint-disable-next-line no-console
        console.warn('initExperiments called while window was undefined. Did you accidentally call this server side?');
        return;
    }

    globalThis.zhlExperiments = {
        ...globalThis.zhlExperiments,
        ...experiments,
    };
    Object.entries(globalThis.zhlExperiments).forEach(async ([experimentName, info]) => {
        await client.addFeatureFlagEvaluation(experimentName, info.treatment);
    });
};
